import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/vercel/path0/apps/web/src/app/(evm)/stake/header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/vercel/path0/apps/web/src/app/(evm)/stake/providers.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/src/ui/stake/BarHeader.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/src/ui/stake/SushiBarProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HotJar"] */ "/vercel/path0/packages/ui/dist/components/scripts.js");
